import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { DropdownComponent } from '../../ui/dropdown/dropdown.component';
import { DropdownItemTwoComponent } from '../../ui/dropdown/dropdown-item/dropdown-item.component-two';
import { AuthService } from '../../../../pages/auth-pages/services/auth.service';
import { User, MyBusiness } from '../../../../pages/auth-pages/models/user.model';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  imports:[CommonModule,RouterModule,DropdownComponent,DropdownItemTwoComponent]
})
export class UserDropdownComponent implements OnInit, OnDestroy {
  isOpen = false;
  currentUser: User | null = null;
  private userSubscription?: Subscription;

  // Switcher de empresa (multi-empresa)
  showSwitchModal = false;
  loadingBusinesses = false;
  switching = false;
  businesses: MyBusiness[] = [];
  switchError = '';

  // Inc 3: menú de opciones de "Support" (mockup opción_soporte.html)
  showSupportMenu = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.userSubscription = this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
  }

  ngOnDestroy(): void {
    this.userSubscription?.unsubscribe();
  }

  /** Iniciales para el avatar del header mientras el usuario no tiene foto. */
  get avatarInitials(): string {
    const first = (this.currentUser?.fullname || '').trim().charAt(0);
    const last = (this.currentUser?.lastname || '').trim().charAt(0);
    return (first + last).toUpperCase() || 'U';
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  openSwitchModal(): void {
    this.closeDropdown();
    this.showSwitchModal = true;
    this.switchError = '';
    this.loadBusinesses();
  }

  closeSwitchModal(): void {
    if (this.switching) return;
    this.showSwitchModal = false;
  }

  private loadBusinesses(): void {
    this.loadingBusinesses = true;
    this.authService.getMyBusinesses().subscribe({
      next: (list) => {
        this.businesses = list;
        this.loadingBusinesses = false;
      },
      error: (err) => {
        this.loadingBusinesses = false;
        this.switchError = err?.error?.message || 'No se pudieron cargar las empresas.';
      }
    });
  }

  selectBusiness(business: MyBusiness): void {
    if (business.current || this.switching) return;
    this.switching = true;
    this.switchError = '';

    this.authService.switchBusiness(business.businessId).subscribe({
      next: () => {
        this.toast.success({ title: 'Empresa cambiada', message: `Ahora estás en ${business.businessName}.` });
        // Recargar para garantizar estado limpio por-tenant (el businessId se lee ad-hoc en muchos sitios).
        setTimeout(() => window.location.reload(), 700);
      },
      error: (err) => {
        this.switching = false;
        const msg = err?.error?.message || 'No se pudo cambiar de empresa.';
        this.switchError = msg;
        this.toast.error({ title: 'Error', message: msg });
      }
    });
  }

  // ── Inc 3: menú de Support ──
  openSupportMenu(): void {
    this.closeDropdown();
    this.showSupportMenu = true;
  }

  closeSupportMenu(): void {
    this.showSupportMenu = false;
  }

  /** Única opción real por ahora: navega a crear un ticket de soporte. */
  onOpenTicket(): void {
    this.closeSupportMenu();
    this.router.navigate(['/tickets/crear']);
  }

  /** Contactar a soporte / Documentación / FAQ / Chat en vivo: aún no implementados. */
  onComingSoon(): void {
    this.closeSupportMenu();
    this.toast.info('Esta opción estará disponible próximamente.');
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/signin']);
  }
}